// @flow
import styled from 'styled-components';
import colors from '../../../assets/css/colors';

export const ResetListButton = styled.button`
	outline: none;
	color: ${colors.nrlDarkGreen};
	border: 1px solid currentColor;
	background: transparent;
	border-radius: 3px;
	font-weight: bold;
	font-size: 12px;
	letter-spacing: 0.5px;
	padding: 10px;
	height: 36px;
	cursor: pointer;
	align-self: center;
	width: 150px;
	line-height: 1.2;
	display: flex;
	justify-content: center;
	margin-left: 10px;
`;

export default ResetListButton;


// WEBPACK FOOTER //
// ./src/pages/league/preDraft/resetListButton.js